import { Card as CardType, BattleTypes } from "../types";

interface BattleCard extends CardType {
  activity: BattleTypes | "other";
}

export const BATTLE_CARDS: BattleCard[] = [
  {
    activity: "other",
    genre: "battle",
    description:
      "Challenge the person to your right to a thumb war. Loser drinks.",
    penaltyCost: 2,

    pub: true,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Plank battle with the person opposite (Winner gets the card, Loser gets the penalty)",
    penaltyCost: 1,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Thumbwar battle with the person opposite (Winner gets the card, Loser gets the penalty)",
    penaltyCost: 1,
    pub: true,
  },
  {
    activity: "dance",
    genre: "battle",
    description:
      "Dance battle with the person opposite (Group decides: Winner gets the card, Loser gets the penalty)",
    penaltyCost: 2,
  },
  {
    activity: "dance",
    genre: "battle",
    description:
      "Twerk dance battle with the person opposite (Group decides: Winner gets the card, Loser gets the penalty)",
    penaltyCost: 2,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Stay put! Play hand sumo with the person opposite! Grip and push but first one to step loses.",
    penaltyCost: 2,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "How low can you go! Battle the person opposite to a limbo-off! ",
    penaltyCost: 2,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Draw/play tic tac toe on yourself with the person to the right. (Win removes penalty. Lose doubles penalty)",
    penaltyCost: 2,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Challenge the person to your left to rock-paper-scissors. Loser drinks.",
    penaltyCost: 2,
    pub: true,
  },
  {
    activity: "dance",
    genre: "battle",
    description:
      "Challenge the person opposite to a seductive dance-off. Loser drinks.",
    penaltyCost: 3,
  },
  {
    activity: "other",
    genre: "battle",
    description: "Staring contest with the person 3 to the left. Loser drinks.",
    penaltyCost: 2,
    pub: true,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Play two truths and a lie with the person 6 to the right. Drink if your lie is caught.",
    penaltyCost: 3,
    pub: true,
  },
  {
    activity: "group",
    genre: "battle",
    description:
      "Compete with the person opposite in a moaning contest; group decides who's better.",
    penaltyCost: 4,
    pub: true,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Strip rock-paper-scissors with person wearing the most: loser removes an article of clothing.",
    penaltyCost: 4,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Challenge the person to your left to a plank off. Loser drinks",
    penaltyCost: 4,
  },
  {
    activity: "other",
    genre: "battle",
    description:
      "Rock paper scissors the person 2 places to your right (Loser gets the penalty)",
    penaltyCost: 2,
    pub: true,
  },
];
